export default [
    {value: 'factory', name: '工厂'},
    {value: 'product_no', name: '产品ID'},
    {value: 'purchase_no', name: '采购单号'},
    {value: 'line_no', name: '行号'},
    {value: 'version_no', name: '版本'},
    {value: 'product_id', name: '客户物料ID'},
    {value: 'customer_short_name', name: '客户简称'},
    {value: 'process_description', name: '工序'},
    {value: 'product_description', name: '物料描述'},
    {value: 'unit_name', name: '单位'},
    {value: 'qty', name: '数量'},
    {value: 'complete_qty', name: '完成数量'},
    {value: 'reconciliation_qty', name: '对账数量'},
    {value: 'plan_delivery_date', name: '计划发货日期'},
    {value: 'delivery_date', name: '交货日期'},
    {value: 'delivery_qty', name: '发货数量'},
    {value: 'stock_place', name: '库存地点'},
    {value: 'temporary_location', name: '自由库位'},
    {value: 'sale_no', name: '销售订单'},
    {value: 'material_description', name: '材料描述'},
    {value: 'check_text', name: '检验文本'},
    {value: 'product_short_description', name: '材料短描述'},
    {value: 'confirm_date', name: '确认日期'},
    {value: 'category_name', name: '产品类别'},
    {value: 'process_group_name', name: '生产工序'},
    {value: 'remark', name: '备注'},
    {value: 'is_printed', name: '已打印'},
    {value: 'guest_name', name: '外宾'},
    {value: 'material_name', name: '主材料名称'},
    {value: 'material_size', name: '主材料规格'},
    {value: 'picture_path', name: '结构图纸'},
    {value: 'die_path', name: '刀模图纸'},
    {value: 'mould_path', name: '模具图纸'},
    {value: 'custom_picture_no', name: '自定义图纸'},
    {value: 'work_order_no', name: '工单号'},
    {value: 'surface_texture', name: '材质+表面处理'},
    {value: 'color', name: '颜色'},
    {value: 'color_no', name: '色样编号'},
    {value: 'size', name: '尺寸'},
    {value: 'package_qty', name: '包装数量'},
    {value: 'makeup_qty', name: '拼板数量'},
    {value: 'product_name', name: '品名'},
    {value: 'tag_qty', name: '贴标数量'},
    {value: 'price', name: '价格'},
    {value: 'price_status', name: '价格状态'},
    {value: 'spare_qty', name: '备件数'},
    {value: 'price_unit', name: '价格单位'},
    {value: 'price_pcs', name: '价格(PCS)'},
    {value: 'sale_detail', name: '销售订单行'},
    {value: 'sale_full_no', name: '销售订单-行'},
    {value: 'reconciliation_date', name: '对账日期'},
    {value: 'order_type', name: '订单类型'},
]
